import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from "react-redux";
import {store} from './store/store';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import "dayjs/locale/fr";
import "@js-joda/timezone";
import ModeWrapper from "./component/ModeWrapper";
import PermissionWrapper from "./component/PermissionWrapper";
import axios from "axios";

axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <PermissionWrapper>
            <ModeWrapper/>
        </PermissionWrapper>
    </Provider>
);